'use client';

import styles from './VideoPlayer.module.scss';
import { useMediaPlaybackState } from '@/lib/hooks/useMediaPlaybackState';

interface PlayButtonProps {
  videoRef: React.RefObject<HTMLVideoElement | null>;
}

export default function PlayButton({ videoRef }: PlayButtonProps) {
  const { isPlaying } = useMediaPlaybackState(videoRef);

  const togglePlayVideo = () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    if (video.paused || video.ended) {
      video.play().catch(() => {});
    }
    else {
      video.pause();
    }
  }

  return (
    <button
      type="button"
      className={styles.playButton}
      onClick={togglePlayVideo}
      aria-pressed={isPlaying}
      aria-label="Play"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isPlaying ? (
          // Pause: Two vertical bars
          <>
            <rect x="4" y="3" width="2.5" height="10" fill="currentColor"/>
            <rect x="9.5" y="3" width="2.5" height="10" fill="currentColor"/>
          </>
        ) : (
          // Play: Triangle
          <path d="M5 3 L13 8 L5 13 Z" fill="currentColor"/>
        )}
      </svg>
    </button>
  );
}
